import { ReactComponent as UpArrow } from "../../assets/icons/spin-arrow.svg";
import React from "react";
import "./styles.css";

const DownArrow = (props) => (
  <UpArrow {...props} style={{ transform: "rotate(180deg)" }} />
);

const UBArrowInput = ({ id, min, max, placeholder, value, setValue, readOnly = false }) => {
  const handleInput = (e) => {
    let inputVal = e.target.value;
    if (
      inputVal === "" ||
      (Number(inputVal) <= max && Number(inputVal) >= min)
    ) {
      setValue(
        inputVal === ""
          ? ""
          : Number(e.target.value.replace(/[^0-9]/g, "")) || 0
      );
    }
  };
  const handleKeyDown = (e) => {
    const inputsToBlock = ["+", "-", ".", "e"];
    if (inputsToBlock.includes(e?.key?.toLowerCase?.())) {
      e.preventDefault();
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    let pasteData = (e.clipboardData || window.clipboardData).getData("text");
    let filteredData = pasteData.replace(/[^0-9.]/g, "");
    const addedNumber = value + filteredData;
    if (
      addedNumber === "" ||
      (Number(addedNumber) <= max && Number(addedNumber) >= min)
    ) {
      setValue(addedNumber);
    }
  };
  const handleIncrement = () => {
    const value = document?.getElementById(id)?.value;
    if (value && (Number(value) || 0) + 1 > max) return;
    else {
      setValue((Number(value) || 0) + 1);
    }
  };
  const handleDecrement = () => {
    const value = document?.getElementById(id)?.value;
    if (value && (Number(value) || 0) - 1 < min) return;
    else {
      setValue((Number(value) || 0) - 1);
    }
  };
  return (
    <div className='ub-num-inp'>
      <input
        readOnly={readOnly}
        placeholder={placeholder}
        onKeyDown={handleKeyDown}
        className='hide_spinner'
        onInput={handleInput}
        onPaste={handlePaste}
        value={value}
        type='number'
        min={min}
        max={max}
        id={id}
      />
      {!readOnly && <div className='arrows'>
        <UpArrow role='button' onClick={handleIncrement} />
        <DownArrow role='button' onClick={handleDecrement} />
      </div>}
    </div>
  );
};

export default UBArrowInput;
